<template>
  <parent>
    <div class="full-height">
      <div class="d-flex justify-content-end mb-1">
        <button-loading
          variant="bg-white"
          class="ml-auto mr-0"
          :spinning="downloadingCertificate"
          @click="downloadCertificate()"
        >
          <GjIcon
            class="icon-left"
            name="Download"
          />
          Download
        </button-loading>
      </div>

      {{ certificate.certificateStatus }}
      <paper-simple>
        <loading-page v-if="gettingCertificate" />
        <template v-else>
          <b-row>
            <b-col sm="6">
              <input-field
                label="Domain Name"
                name="name"
                label-position="top"
              >
                {{ certificate.domainName || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                name="additionalNames"
                label="Additional Names"
                label-position="top"
              >
                {{ certificate.additionalNames || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Certificate Status"
                name="certificateStatus"
                label-position="top"
              >
                <certificate-status :type="certificate.certificateStatus" />
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Certificate Type"
                name="certificateType"
                label-position="top"
              >
                {{ certificate.certificateType }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="SSL Certificate Id"
                name="sslCertificateId"
                label-position="top"
              >
                <a
                  v-clipboard:copy="certificate.sslCertificateId"
                  v-clipboard:success="copySuccess"
                >
                  {{ certificate.sslCertificateId || '-' }}
                  <GjIcon
                    name="Copy"
                    size="17"
                  />
                </a>
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Scope"
                name="Scope"
                label-position="top"
              >
                {{
                  getObjectOptionsText(
                    certificate.scopeOptions,
                    certificate.scopeId,
                  ) || '-'
                }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Not Before"
                name="notBefore"
                label-position="top"
              >
                {{ formatOffsetDateTime(certificate.notBefore) || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Not After"
                name="notAfter"
                label-position="top"
              >
                {{ formatOffsetDateTime(certificate.notAfter) || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Issuer"
                name="issuer"
                label-position="top"
              >
                {{ certificate.issuer || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Public Key Info"
                name="publicKeyInfo"
                label-position="top"
              >
                {{ certificate.publicKeyInfo || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Serial Number"
                name="serialNumber"
                label-position="top"
              >
                {{ certificate.serialNumber || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Signature Algorithm"
                name="signatureAlgorithm"
                label-position="top"
              >
                {{ certificate.signatureAlgorithm || '-' }}
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Renew Message"
                name="renewMessage"
                label-position="top"
              >
                <custom-alert
                  v-if="
                    certificate.renewMessage &&
                      certificate.renewMessage !== 'Successful'
                  "
                  items-center
                  icon-name="InfoAlt"
                  variant="danger"
                  class="text-break"
                  :text="certificate.renewMessage"
                />
                <template v-else>
                  {{ certificate.renewMessage || '-' }}
                </template>
              </input-field>
            </b-col>
            <b-col sm="6">
              <input-field
                label="Renewed At"
                name="renewedAt"
                label-position="top"
              >
                {{ formatOffsetDateTime(certificate.renewedAt) || '-' }}
              </input-field>
            </b-col>
          </b-row>

          <template v-if="validate">
            <custom-alert
              items-center
              icon-name="InfoAlt"
              class="mt-2"
            >
              <div class="d-flex justify-content-between aling-items-center flex-md-row">
                <p>
                  <strong>Important: </strong>
                  Waiting for you to confirm the
                  challenge, please click Validate once you've completed the
                  challenge
                </p>
                <div>
                  <b-spinner
                    class="my-2 my-md-0 ml-3"
                    variant="primary"
                    label="Text Centered"
                  />
                </div>
              </div>

            </custom-alert>
          </template>
        </template>
      </paper-simple>
      <div
        v-if="certificate.domains && certificate.domains.length > 0"
        class="default-table"
      >
        <div class="table-actions">
          <label>Domains</label>
        </div>
        <b-table
          ref="table"
          class="loaded mb-0"
          :items="certificate.domains"
          :fields="domainFields"
          responsive
        >
          <template #cell(name)="data">
            <a
              v-clipboard:copy="data.value"
              v-clipboard:success="copySuccess"
            >
              {{ data.value || '-' }}
              <GjIcon
                name="Copy"
                size="17"
              />
            </a>
          </template>
          <template #cell(value)="data">
            <a
              v-clipboard:copy="data.value"
              v-clipboard:success="copySuccess"
            >
              {{ data.value || '-' }}
              <GjIcon
                name="Copy"
                size="17"
              />
            </a>
          </template>
        </b-table>
      </div>
    </div>
  </parent>
</template>
<script>
export default {
  components: {
    CertificateStatus: () => import('./components/CertificateStatus.vue'),
  },
  props: {
    validate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      domainFields: [
        { key: 'domain', tdClass: 'customized-width' },
        { key: 'status', tdClass: 'customized-width' },
        // 'renewalStatus',
        'type',
        { key: 'name', tdClass: 'customized-width' },
        { key: 'value', tdClass: 'customized-width' },
      ],
    }
  },
  computed: {
    certificate() {
      return this.$store.state.cdn.certificate
    },
    downloadingCertificate() {
      return this.$store.state.cdn.downloadingCertificate
    },
    gettingCertificate() {
      return this.$store.state.cdn.gettingCertificate
    },
    certificateId() {
      return this.$route.params.certificateId
    },
  },
  methods: {
    downloadCertificate() {
      const domainName = this.certificate.domainName.replace('*', 'STAR').replace(/\./g, '_')
      this.$store.dispatch('cdn/downloadCertificate', {
        certificateId: this.certificateId,
        certificateName: domainName,
      })
    },
  },
}
</script>
<style lang="scss" scoped>

.default-table::v-deep {
  .card-body {
    padding: 0 !important;
  }
  .customized-width {
    text-overflow: initial;
    max-width: none;
  }
}
</style>
